import styled from "styled-components";
import { Wrapper } from 'AppReact';

const HeaderRow = styled.tr`
  th {
    border-bottom: 1px solid #E7EBEB;
    background: #FFFFFF;
    height: 40px;
  }
`;

export default Wrapper(HeaderRow)